import { Reveal, SectionHead } from "@/components/Reveal";

const PROBLEMS = [
  {
    code: "STRATEGY",
    quote: "We know what we want to achieve — but need clarity and priorities.",
    testid: "problem-card-strategy",
  },
  {
    code: "EXECUTION",
    quote:
      "We have ideas and initiatives — but need a better way to organize and deliver them.",
    testid: "problem-card-execution",
  },
  {
    code: "SYSTEMS",
    quote:
      "We are doing too much manually — and need better processes, AI or automation.",
    testid: "problem-card-systems",
  },
];

export default function Problem() {
  return (
    <section
      id="how-it-works"
      data-testid="problem-section"
      className="scroll-mt-20 py-20 sm:py-28 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead
          chapter="01 — The Problem"
          title="Strategy is only useful if you can execute it."
          copy="Many founders and organizations know where they want to go — but the strategy, processes, teams and systems needed to get there are not always connected. KP Strategy helps connect the dots."
          testid="problem-head"
        />
        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
          {PROBLEMS.map((p, i) => (
            <Reveal key={p.code} delay={i * 0.1}>
              <div
                data-testid={p.testid}
                className="group h-full border border-line bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:border-amber/60 sm:p-10"
              >
                <p className="font-mono text-xs uppercase tracking-[0.25em] text-amber">
                  {p.code}
                </p>
                <p className="mt-6 font-serif text-xl font-normal leading-snug text-ink sm:text-2xl">
                  “{p.quote}”
                </p>
                <span className="mt-8 block h-px w-full bg-line transition-colors duration-300 group-hover:bg-amber/40" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
